import React from "react";

export default function MenuItemPlaceholder() {
  return <div className="mx-8 mb-4 md:w-1/2" />;
}
